<template lang="pug">
#modal-diagnostico-socioambiental
    el-dialog(
        :title='$t("mensagens.pessoas.diagnosticoSocioambiental")',
        width='800px',
        :visible.sync='mostrar',
        :before-close='fechar'
    )
        p
            b {{ $t('mensagens.comuns.nome') }}:
            |
            | {{ dadosRepresentante.nome }}

        p
            b(v-if='usuarioLogado.ambienteLogado === this.ambientes.PARAGUAY') {{ $t('mensagens.pessoas.ruc') }}:

            b(
                v-else-if='usuarioLogado.ambienteLogado === this.ambientes.ARGENTINA'
            ) {{ $t('mensagens.pessoas.cuit') }}:

            b(v-else) {{ $t('mensagens.pessoas.numeroCpfCnpj') }}:
            |
            | {{ dadosRepresentante.cpfCnpj || dadosRepresentante.documento }}

        p(v-if='dadosRepresentante.email')
            b {{ $t('mensagens.comuns.email') }}:
            |
            | {{ dadosRepresentante.email }}

        .modal-diagnostico-socioambiental__btn-confimar.mt-3(
            v-if='!consultaRealizada && usuarioLogado.ambienteLogado !== ambientes.PARAGUAY && usuarioLogado.ambienteLogado !== ambientes.ARGENTINA'
        )
            el-button(
                type='primary',
                size='large',
                key='btnRealizarDiagnostico',
                @click='realizarDiagnosticoSocioambietal'
            ) {{ $t('mensagens.pessoas.realizarDiagnosticoSocioambiental') }}

        template(v-else)
            DiagnosticoSocioambiental.mb-3(
                :dadosConsulta='resultadoDiagnostico',
                :cpfCnpj='dadosRepresentante.documento'
            )

            .modal-diagnostico-socioambiental__btn-exportacao
                el-button(
                    v-if='usuarioLogado.ambienteLogado !== ambientes.PARAGUAY && usuarioLogado.ambienteLogado !== ambientes.ARGENTINA',
                    type='primary',
                    key='btnMarcarExportcao',
                    size='mini',
                    @click='marcarExportacaoDiagnosticoPdf',
                    :loading='loadingPDF'
                )
                    | {{ $t('mensagens.pessoas.marcarParaExportacao') }}

                el-button(
                    v-if='usuarioLogado.ambienteLogado !== ambientes.PARAGUAY && usuarioLogado.ambienteLogado !== ambientes.ARGENTINA',
                    type='primary',
                    key='btnExportar',
                    size='mini',
                    @click='exportarPdfDiagnosticoSocio',
                    :loading='loadingPDF'
                )
                    | {{ $t('mensagens.pessoas.exportarDiagnostico') }}

        footer(slot='footer')
            el-button(size='mini', @click='fechar') {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';

import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';

import formatters from '@/utils/formatters';
import { retryOperation } from '@/utils/retry-operation';
import { connect, subscribe, disconnect } from '@/utils/websocket';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'DiagnosticoSociambientealRepresentante',

    components: {
        DiagnosticoSocioambiental
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        dadosRepresentante: {
            type: Object,
            required: true
        },

        confirmar: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            resultadoDiagnostico: {},
            consultaRealizada: false,
            loadingPDF: false,
            ambientes: AmbientesEmpresas
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    watch: {
        mostrar() {
            if (this.mostrar && !this.confirmar) {
                this.realizarDiagnosticoSocioambietal();
            }
        }
    },

    methods: {
        ...mapActions(['setprocessandoMonitoramento', 'setMarcarExportar_PDF']),

        fechar() {
            this.resultadoDiagnostico = {};
            this.consultaRealizada = false;
            this.$emit('fechar');
        },

        async realizarDiagnosticoSocioambietal() {
            const numeroCpfCnpj = formatters.cpfCnpjFormatToNumeral(
                this.dadosRepresentante.documento
            );
            const { data } = await DiagnosticoSocioambientalService.consultar(
                'CPF_CNPJ',
                numeroCpfCnpj
            );
            this.resultadoDiagnostico = { diagnostico: data.dataCAR };
            this.consultaRealizada = true;
        },

        async exportarPdfDiagnosticoSocio() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.naoFoiPossivelConectarApiPdf'
                    )
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/exportar/pdf/diagnostico/socio`,
                    response => {
                        if (response) {
                            const linkSource = `data:application/pdf;base64,${response}`;
                            const link = document.createElement('a');
                            const fileName = 'diagnosticos-socioambientais.pdf';

                            const currentDate = new Date();
                            const formattedDate = `${currentDate.getFullYear()}${String(
                                currentDate.getMonth() + 1
                            ).padStart(2, '0')}${String(
                                currentDate.getDate()
                            ).padStart(2, '0')}`;
                            const formattedTime = `${String(
                                currentDate.getHours()
                            ).padStart(2, '0')}${String(
                                currentDate.getMinutes()
                            ).padStart(2, '0')}${String(
                                currentDate.getSeconds()
                            ).padStart(2, '0')}`;

                            const newFileName = fileName.replace(
                                '.pdf',
                                `-${formattedDate}-${formattedTime}.pdf`
                            );

                            link.href = linkSource;
                            link.download = newFileName;
                            link.click();
                            link.remove();
                        } else {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.pessoas.naoFoiPossivelExportarPdf'
                                )
                            });
                        }
                        this.loadingPDF = false;
                        disconnect();
                    }
                );

                this.loadingPDF = true;
                const documento = formatters.cpfCnpjFormatToNumeral(
                    this.dadosRepresentante.documento
                );

                const params = {
                    idTerritorio: null,
                    tipoDocumento: 'CPF_CNPJ',
                    documento: documento,
                    camadas: null,
                    nome: 'CPF/CNPJ ' + documento,
                    buffer: null
                };

                const dados = [];
                dados.push(params);

                retryOperation(
                    DiagnosticoSocioambientalService.exportarPdf,
                    dados,
                    5000,
                    10
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.naoFoiPossivelExportarPdf'
                    )
                });
                disconnect();
            }
        },

        marcarExportacaoDiagnosticoPdf() {
            const documento = formatters.cpfCnpjFormatToNumeral(
                this.dadosRepresentante.documento
            );
            const params = {
                idLista: Math.floor(Date.now() * Math.random()).toString(36),
                idTerritorio: null,
                tipoDocumento: 'CPF_CNPJ',
                documento: documento,
                camadas: null,
                nome: 'CPF/CNPJ ' + documento,
                buffer: null
            };

            this.setMarcarExportar_PDF(params);
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-diagnostico-socioambiental__btn-confimar {
    display: flex;
    justify-content: center;
}

.modal-diagnostico-socioambiental__btn-exportacao {
    display: flex;
    justify-content: space-between;
}
</style>
